import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#c87035";
function ZCL({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M11.994 20.25c-4.556-.003-8.244-3.698-8.244-8.26 0-4.554 3.699-8.243 8.261-8.24 4.549.003 8.245 3.7 8.239 8.252-.009 4.501-3.627 8.242-8.256 8.248m-3.362-4.477q.034-.067.058-.108 1.108-1.953 2.217-3.902.973-1.708 1.939-3.418a.11.11 0 01.113-.068q1.13.005 2.26.004h.108l-3.13 5.52.079.003q2.834 0 5.664.003c.064 0 .084-.024.098-.079a6.24 6.24 0 00-1.735-6.251 5.7 5.7 0 00-1.38-.973 6.16 6.16 0 00-3.963-.6c-1.38.245-2.543.897-3.496 1.928-.125.135-.239.28-.358.42.003.008.01.014.012.022h5.385c-.03.056-.05.097-.073.135-.328.582-.66 1.161-.985 1.744a.15.15 0 01-.152.087q-2.544-.005-5.087-.003h-.103c-.859 2.702.355 6.091 3.401 7.447 2.949 1.317 6.041.105 7.491-1.918q-4.18.009-8.362.006zm9.482 1.423c1.046-1.163 1.976-3.075 1.918-5.372-.047-1.892-.695-3.555-1.906-5.025-.378.38-.747.75-1.113 1.12 1.92 2.31 2.002 5.724.02 8.176z" /></Svg>;
}
ZCL.DefaultColor = DefaultColor;
export default ZCL;